import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetPayableDetailsQuery } from "../../../services/Reports";
import {
  getPayableDetailsRequest,
  getPayableDetailsFailure,
  getPayableDetailsSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allPayableDetails,
    isLoading: payableDetailsLoading,
    isError: payableDetailsError,
  } = useGetPayableDetailsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.payableDetailsPageNo,
    pageSize: state.payableDetailsPageSize,
    fromDate: new Date(state.payableDetailsFromDate).toLocaleDateString(),
    toDate: new Date(state.payableDetailsToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (payableDetailsLoading) {
      dispatch(getPayableDetailsRequest());
    }
    if (payableDetailsError) {
      dispatch(getPayableDetailsFailure(payableDetailsError));
    }
    if (allPayableDetails) {
      dispatch(
        getPayableDetailsSuccess({
          data: allPayableDetails.data.payableDetails[0].data || [],
          totalPages:
            allPayableDetails.data.payableDetails[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allPayableDetails,
    profileData,
    state.payableDetailsFromDate,
    state.payableDetailsToDate,
    state.payableDetailsPageNo,
    state.payableDetailsPageSize,
  ]);
  return <></>;
};
export default Content;
